import React, { useEffect, useState, useRef } from "react";
import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";
import Usercard from "../../components/Usercard";
import api, { baseURL } from "../../Axios";
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  Table,
  TabPane,
} from "reactstrap";

const NewJoin = () => {
  const [imageveri, setImageveri] = useState([]);
  const [imagepend, setImagepend] = useState([]);
  const [horopend, setHoropend] = useState([]);
  const [incompleProfile, setIncompleteProfile] = useState([]);

  const [horoveri, setHoroveri] = useState([]);
  const [eduveri, setEduveri] = useState([]);
  const [aadharveri, setAadharveri] = useState([]);
  const [planveri, setPlanveri] = useState([]);
  const [houseveri, setHouseveri] = useState([]);
  const [newjoin, setNewjoin] = useState([]);

  const [allverify, setAllverify] = useState([]);

  const [horoscopeVeri, setHoroscopeVeri] = useState([]);
  const [multiImageVeri, setMultiImageVeri] = useState([]);
  const [activeTab, setActiveTab] = useState("1");

  const imageRefs = useRef({});
  const cropperRef = useRef({});
  const multiImageRefs = useRef({});
  const multiCropperRefs = useRef({});
  const [data, setData] = useState([]);

  const [selectedImages, setSelectedImages] = useState({}); // for checkboxes

  useEffect(() => {
    if (activeTab === "1") {
      fetchNewJoin();
    }
  }, [activeTab]);

  const fetchImageVerification = async () => {
    try {
      const res = await api.get("/admin/approvals/profilePicNotVerified");
      setImageveri(res.data.data);
      const pending = res.data.data.filter((item) => item.profilePic === null);
      setImagepend(pending);
    } catch (err) {
      console.error("Error fetching image verification:", err);
    }
  };

  const fetchNewJoin = async () => {
    try {
      const res = await api.get("/admin/adminDashboard/recentMembers");
      setNewjoin(res.data.data);
    } catch (err) {
      console.error("Error fetching New join", err);
    }
  };
  const fetchHoroscopeVerification = async () => {
    try {
      const res = await api.get("/admin/approvals/horoscopeNotVerified");
      setHoroveri(res.data.data);
      const pending = res.data.data.filter((item) => item.horoscope === null);
      setHoropend(pending);
    } catch (err) {
      console.error("Error fetching horoscope verification:", err);
    }
  };

  const fetchAadharVerification = async () => {
    try {
      const res = await api.get("/admin/approvals/aadharNotVerified");
      setAadharveri(res.data.data);
    } catch (err) {
      console.error("Error fetching Aadhaar Verification:", err);
    }
  };

  const fetchPlanVerification = async () => {
    try {
      const res = await api.get("admin/membership/requestedPlansList");
      setPlanveri(res.data.data);
    } catch (err) {
      console.error("Error fetching plan verification:", err);
    }
  };

  const fetchIncompleProfile = async () => {
    try {
      const res = await api.get("/admin/adminDashboard/incompleteProfiles");
      setIncompleteProfile(res.data.data);
    } catch (err) {
      console.error("Error fetching all verified members:", err);
    }
  };
  const [fetchedTabs, setFetchedTabs] = useState({});

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);

    if (!fetchedTabs[tabId]) {
      switch (tabId) {
        case "1":
          fetchNewJoin();
          break;
        case "2":
          fetchImageVerification();

          break;
        case "3":
          fetchImageVerification();
          break;
        case "4":
          fetchHoroscopeVerification();
          break;
        case "5":
          fetchHoroscopeVerification();
          break;
        case "6":
          fetchAadharVerification();
          break;
        case "7":
          fetchIncompleProfile();
          break;
        case "8":
          fetchPlanVerification();
          break;
        default:
          break;
      }
      setFetchedTabs((prev) => ({ ...prev, [tabId]: true }));
    }
  };
  const [getuser, setGetuser] = useState([]);

  function deletee(i) {
    api
      .post("/admin/manageuserProfile/terminateUser", { id: i.id })
      .then(() => {
        api.get("/admin/adminDashboard/recentMembers").then((res) => {
          setGetuser(res.data.data);
        });
      });
  }
  function activeinactive(i) {
    api.post("/admin/manageuserProfile/deleteUser", { id: i.id }).then(() => {
      api.get("/admin/adminDashboard/recentMembers").then((res) => {
        setGetuser(res.data.data);
      });
    });
  }
  return (
    <div className="col-12">
      <Row>
        <Col xs={12}>
          <div className="page-title">
            <h1 className="title">New Members Approvals</h1>
          </div>
          <section className="box">
            <div style={{ padding: "25px", backgroundColor: "white" }}>
              <Nav tabs style={{ display: "flex", flexWrap: "wrap" }}>
                <NavItem style={{ flex: "1 0 12.5%", textAlign: "center" }}>
                  <NavLink
                    style={{ padding: "5px 10px" }}
                    className={activeTab === "1" ? "active" : ""}
                    onClick={() => handleTabClick("1")}
                  >
                    New Join
                  </NavLink>
                </NavItem>{" "}
                <NavItem style={{ flex: "1 0 12.5%", textAlign: "center" }}>
                  <NavLink
                    style={{ padding: "5px 10px" }}
                    className={activeTab === "2" ? "active" : ""}
                    onClick={() => handleTabClick("2")}
                  >
                    Image Verification
                  </NavLink>
                </NavItem>
                <NavItem style={{ flex: "1 0 12.5%", textAlign: "center" }}>
                  <NavLink
                    style={{ padding: "5px 10px" }}
                    className={activeTab === "3" ? "active" : ""}
                    onClick={() => handleTabClick("3")}
                  >
                    Image Pending
                  </NavLink>
                </NavItem>
                <NavItem style={{ flex: "1 0 12.5%", textAlign: "center" }}>
                  <NavLink
                    style={{ padding: "5px 10px" }}
                    className={activeTab === "4" ? "active" : ""}
                    onClick={() => handleTabClick("4")}
                  >
                    Horoscope Verification
                  </NavLink>
                </NavItem>
                <NavItem style={{ flex: "1 0 12.5%", textAlign: "center" }}>
                  <NavLink
                    style={{ padding: "5px 10px" }}
                    className={activeTab === "5" ? "active" : ""}
                    onClick={() => handleTabClick("5")}
                  >
                    Horoscope Pending
                  </NavLink>
                </NavItem>
                <NavItem style={{ flex: "1 0 12.5%", textAlign: "center" }}>
                  <NavLink
                    style={{ padding: "5px 10px" }}
                    className={activeTab === "6" ? "active" : ""}
                    onClick={() => handleTabClick("6")}
                  >
                    Aadhaar Verification
                  </NavLink>
                </NavItem>
                <NavItem style={{ flex: "1 0 12.5%", textAlign: "center" }}>
                  <NavLink
                    style={{ padding: "5px 10px" }}
                    className={activeTab === "7" ? "active" : ""}
                    onClick={() => handleTabClick("7")}
                  >
                    Incomplete Profile
                  </NavLink>
                </NavItem>
                <NavItem style={{ flex: "1 0 12.5%", textAlign: "center" }}>
                  <NavLink
                    style={{ padding: "5px 10px" }}
                    className={activeTab === "8" ? "active" : ""}
                    onClick={() => handleTabClick("8")}
                  >
                    Plan Approvel
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={activeTab} className="pt-4">
                <TabPane tabId="1">
                  <Row>
                    {Array.isArray(newjoin) && newjoin.length > 0 ? (
                      newjoin.map((user, index) => {
                        return (
                          <Usercard
                            id={user.id}
                            key={index}
                            profileId={user.profileId}
                            name={user.userName}
                            image={user.profilePic}
                            age={user.age}
                            gender={user.gender}
                            taluk={user.taluk}
                            district={user.district}
                            dob={user.dob}
                            state={user.state}
                            status={user.status}
                            onActive={() => activeinactive(user)}
                            onDelete={() => deletee(user)}
                          />
                        );
                      })
                    ) : (
                      <div style={{ marginLeft: "500px", marginTop: "250px" }}>
                        <h3> Profile Not Found</h3>
                      </div>
                    )}
                  </Row>
                </TabPane>
                <TabPane tabId="2">
                  <Row>
                    {" "}
                    {Array.isArray(imageveri) && imageveri.length > 0 ? (
                      imageveri.map((user, index) => {
                        return (
                          <Usercard
                            key={index}
                            id={user.id}
                            profileId={user.profileId}
                            name={user.userName}
                            image={user.profilePic}
                            age={user.age}
                            gender={user.gender}
                            taluk={user.taluk}
                            district={user.district}
                            dob={user.dob}
                            state={user.state}
                            status={user.status}
                            onActive={() => activeinactive(user)}
                            onDelete={() => deletee(user)}
                          />
                        );
                      })
                    ) : (
                      <div style={{ marginLeft: "500px", marginTop: "250px" }}>
                        <h3> Profile Not Found</h3>
                      </div>
                    )}
                  </Row>
                </TabPane>
                <TabPane tabId="3">
                  <Row>
                    {" "}
                    {Array.isArray(imagepend) && imagepend.length > 0 ? (
                      imagepend.map((user, index) => {
                        return (
                          <Usercard
                            key={index}
                            id={user.id}
                            profileId={user.profileId}
                            name={user.userName}
                            image={user.profilePic}
                            age={user.age}
                            gender={user.gender}
                            taluk={user.taluk}
                            district={user.district}
                            dob={user.dob}
                            state={user.state}
                            status={user.status}
                            onActive={() => activeinactive(user)}
                            onDelete={() => deletee(user)}
                          />
                        );
                      })
                    ) : (
                      <div style={{ marginLeft: "500px", marginTop: "250px" }}>
                        <h3> Profile Not Found</h3>
                      </div>
                    )}
                  </Row>
                </TabPane>
                <TabPane tabId="4">
                  <Row>
                    {" "}
                    {Array.isArray(horoveri) && horoveri.length > 0 ? (
                      horoveri.map((user, index) => {
                        return (
                          <Usercard
                            key={index}
                            id={user.id}
                            profileId={user.profileId}
                            name={user.userName}
                            image={user.profilePic}
                            age={user.age}
                            gender={user.gender}
                            taluk={user.taluk}
                            district={user.district}
                            dob={user.dob}
                            state={user.state}
                            status={user.status}
                            onActive={() => activeinactive(user)}
                            onDelete={() => deletee(user)}
                          />
                        );
                      })
                    ) : (
                      <div style={{ marginLeft: "500px", marginTop: "250px" }}>
                        <h3> Profile Not Found</h3>
                      </div>
                    )}
                  </Row>
                </TabPane>{" "}
                <TabPane tabId="5">
                  <Row>
                    {" "}
                    {Array.isArray(horopend) && horopend.length > 0 ? (
                      horopend.map((user, index) => {
                        return (
                          <Usercard
                            key={index}
                            id={user.id}
                            profileId={user.profileId}
                            name={user.userName}
                            image={user.profilePic}
                            age={user.age}
                            gender={user.gender}
                            taluk={user.taluk}
                            district={user.district}
                            dob={user.dob}
                            state={user.state}
                            status={user.status}
                            onActive={() => activeinactive(user)}
                            onDelete={() => deletee(user)}
                          />
                        );
                      })
                    ) : (
                      <div style={{ marginLeft: "500px", marginTop: "250px" }}>
                        <h3> Profile Not Found</h3>
                      </div>
                    )}
                  </Row>
                </TabPane>
                <TabPane tabId="6">
                  <Row>
                    {Array.isArray(aadharveri) && aadharveri.length > 0 ? (
                      aadharveri.map((user, index) => {
                        return (
                          <Usercard
                            key={index}
                            id={user.id}
                            profileId={user.profileId}
                            name={user.userName}
                            image={user.profilePic}
                            age={user.age}
                            gender={user.gender}
                            taluk={user.taluk}
                            district={user.district}
                            dob={user.dob}
                            state={user.state}
                            status={user.status}
                            onActive={() => activeinactive(user)}
                            onDelete={() => deletee(user)}
                          />
                        );
                      })
                    ) : (
                      <div style={{ marginLeft: "500px", marginTop: "250px" }}>
                        <h3> Profile Not Found</h3>
                      </div>
                    )}{" "}
                  </Row>
                </TabPane>
                <TabPane tabId="7">
                  <Row>
                    {Array.isArray(incompleProfile) &&
                    incompleProfile.length > 0 ? (
                      incompleProfile.map((user, index) => {
                        return (
                          <Usercard
                            key={index}
                            id={user.id}
                            profileId={user.profileId}
                            name={user.userName}
                            image={user.profilePic}
                            age={user.age}
                            gender={user.gender}
                            taluk={user.taluk}
                            district={user.district}
                            dob={user.dob}
                            state={user.state}
                            status={user.status}
                            onActive={() => activeinactive(user)}
                            onDelete={() => deletee(user)}
                          />
                        );
                      })
                    ) : (
                      <div style={{ marginLeft: "500px", marginTop: "250px" }}>
                        <h3> Profile Not Found</h3>
                      </div>
                    )}{" "}
                  </Row>
                </TabPane>
                <TabPane tabId="8">
                  {" "}
                  <Row>
                    {Array.isArray(planveri) && planveri.length > 0 ? (
                      planveri.map((user, index) => {
                        return (
                          <Usercard
                            key={index}
                            id={user.id}
                            profileId={user.profileId}
                            name={user.userName}
                            image={user.profilePic}
                            age={user.age}
                            gender={user.gender}
                            taluk={user.taluk}
                            district={user.district}
                            dob={user.dob}
                            state={user.state}
                            status={user.status}
                            onActive={() => activeinactive(user)}
                            onDelete={() => deletee(user)}
                          />
                        );
                      })
                    ) : (
                      <div style={{ marginLeft: "500px", marginTop: "250px" }}>
                        <h3> Profile Not Found</h3>
                      </div>
                    )}{" "}
                  </Row>
                </TabPane>{" "}
              </TabContent>
            </div>
          </section>
        </Col>
      </Row>
    </div>
  );
};

export default NewJoin;
